import { createSlice } from '@reduxjs/toolkit';
import apolloClient from '../queries';
import { FetchPlans } from '../queries/index.graphql';
import { setSearchedHotelsInput } from './hotel';

const initialState = {
  fetching: false,
  queryParamsValidated: false,
  plans: [],
  paginatorInfo: undefined,
  hotelId: undefined,
};


const planSlice = createSlice({
  name: 'plan',
  initialState,
  reducers: {
    setFetchingPlan: {
      reducer(state, action) {
        const { fetching } = action.payload;
        state.fetching = fetching;
      },
      prepare(fetching) {
        return { payload: { fetching } };
      }
    },
    setQueryParamsValidatedPlan: {
      reducer(state, action) {
        const { validated } = action.payload;
        state.queryParamsValidated = validated;
      },
      prepare(validated) {
        return { payload: { validated } };
      }
    },
    setPlans: {
      reducer(state, action) {
        const { plans } = action.payload;
        state.plans = plans;
        // state.searchedHotelsInput = state.hotelsInput;
        // TODO
        // searchedHotelsInputを変更する処理を入れないがそれは多分、再検索の時にView側でしこむ
      },
      prepare(plans) {
        return { payload: { plans } };
      }
    },
    setPaginatorInfo: {
      reducer(state, action) {
        const { paginatorInfo } = action.payload;
        state.paginatorInfo = paginatorInfo;
      },
      prepare(paginatorInfo) {
        return { payload: { paginatorInfo } };
      }
    },
    setHotelId: {
      reducer(state, action) {
        const { hotelId } = action.payload;
        state.hotelId = hotelId;
      },
      prepare(hotelId) {
        return { payload: { hotelId } };
      }
    },
  },
});

export const {
  setFetchingPlan,
  setQueryParamsValidatedPlan,
  setPlans,
  setPaginatorInfo,
  setHotelId,
} = planSlice.actions;

export const fetchPlans = (plansInput, hotelsInput, first, page, callback) => async (dispatch) => {
  dispatch(setFetchingPlan(true));

  try {
    const { data } = await apolloClient.query({
      query: FetchPlans,
      variables: {
        input: plansInput,
        first,
        page,
      },
      fetchPolicy: 'no-cache',
    });

    const {
      plans,
    } = data;
    dispatch(setPlans(plans.data));
    dispatch(setPaginatorInfo(plans.paginatorInfo));

    dispatch(setSearchedHotelsInput(hotelsInput));

  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  } finally {
    dispatch(setFetchingPlan(false));

    callback && callback();
  }
};


export const handleQueryParamsPlanList = (queryParams) => (dispatch) => {
  const { h } = queryParams;
  dispatch(setHotelId(h));

  dispatch(setQueryParamsValidatedPlan(true));
};

export default planSlice.reducer;
